import { DataPoint } from '@src/types/DataPoint';
import { Device } from '@src/types/Device';
import { PointConfigRef } from '@src/types/Widget';
import { createFieldIdentifier } from '@src/utils/gridUtils';
import { DeviceDataTableRow } from './types';

export function createRow(
  data: DataPoint[],
  pointConfigRefs: PointConfigRef[],
  id: string,
  name?: string,
): DeviceDataTableRow {
  const row = { id, name } as DeviceDataTableRow;

  pointConfigRefs.forEach((point) => {
    const fieldIdentifier = createFieldIdentifier(point);

    const dataPoint = data.find((d) => {
      if (fieldIdentifier.sourceDeviceId) {
        return (
          d.controllerId === id &&
          d.pointAlias === fieldIdentifier.pointAlias &&
          d.overrideSourceDeviceId === fieldIdentifier.sourceDeviceId
        );
      }

      const deviceId = d.sourceDeviceId || d.controllerId;
      return deviceId === id && d.pointAlias === fieldIdentifier.pointAlias;
    });

    if (dataPoint) {
      row[fieldIdentifier.fieldName] = dataPoint;
    }
  });

  return row;
}

export function getRows(
  data: DataPoint[],
  pointAliases: PointConfigRef[],
  devices?: Device[],
): DeviceDataTableRow[] {
  return (
    devices?.map((device) =>
      createRow(data, pointAliases, device.engineeringId, device.name),
    ) || []
  );
}
